import React from 'react';

import { Trans } from '@lingui/macro';
import { LoadingButton } from '@mui/lab';

import { BUTTON_WIDTH } from './style';

interface Props {
    disabled?: boolean;
    onClick: () => void;
    loading?: boolean;
}

const ValidateAction = ({ disabled, onClick, loading }: Props) => (
    <LoadingButton
        sx={{ width: BUTTON_WIDTH }}
        color="primary"
        variant="outlined"
        disabled={disabled}
        onClick={onClick}
        data-testid="validateAction"
        loading={loading}
    >
        <Trans>Validate</Trans>
    </LoadingButton>
);

export default ValidateAction;
